// extracted by mini-css-extract-plugin
export default {"body":"PpsnClaimBlockedDialog_body__GJHOa","text":"PpsnClaimBlockedDialog_text__oIH2w","actions":"PpsnClaimBlockedDialog_actions__f6hUN"};